import { createAction } from '@reduxjs/toolkit';

import { withPayloadType } from 'utils/payloadType';

import * as constants from './constants';

const setSecLevelAction = createAction(
  constants.SET_SEC_LEVEL,
  withPayloadType<number>(),
);

const resetSecLevelAction = createAction(constants.RESET_SEC_LEVEL);

export { setSecLevelAction, resetSecLevelAction };

export type ActionTypes =
  | ReturnType<typeof setSecLevelAction>
  | ReturnType<typeof resetSecLevelAction>;
